export enum Language {
  HU = 'hu',
  PL = 'pl',
}
